import { TLoanApplicationDTO } from './types/DTO/loanApplication';

// Lazy load MSW only when needed
const params = new URLSearchParams(window.location.search);
const shouldMock = params.get('msw') === 'true';

// Only enable MSW in non-production environments
if (import.meta.env.MODE !== 'production' && shouldMock) {
  import('msw').then(({ http, HttpResponse }) => {
    import('msw/browser').then(({ setupWorker }) => {
      const createIndicativeOfferHandler = (
        response: TLoanApplicationDTO['getIndicativeOfferRes']
      ) =>
        http.get(
          `${
            import.meta.env.VITE_API_SVC_ONBOARDING_BASE_URL
          }/country/*/indicative-offer/*`,
          () => {
            return HttpResponse.json(response);
          }
        );

      const worker = setupWorker();
      worker.start({ onUnhandledRequest: 'bypass' });

      const shouldMockIO = params.get('mockIO') === 'true';
      if (shouldMockIO) {
        worker.use(
          createIndicativeOfferHandler({
            showIndicativeOffer: true,
            minAmount: 80000,
            maxAmount: 250000,
          })
        );
      }
    });
  });
}
